import React, { useEffect, useState } from 'react';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import axios from 'axios';
import Spacing from '../Spacing';
import { BASE_URL } from "../../helpers/api";


export default function BlogDetails() {
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const id = localStorage.getItem("selectedBlogId");

    if (!id) return;

    axios
      .post(`${BASE_URL}/blog-details`, { id })
      .then(res => setBlog(res.data))
      .catch(err => console.log('Blog Details Error:', err));
  }, []);

  // if (!blog) {
  //   return (
  //     <div className="container">
  //       <h3>Loading...</h3>
  //     </div>
  //   );
  // }

   if (!blog) {
  return (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "60vh",
      width: "100%",
      fontSize: "24px",
      fontWeight: "600",
    }}
  >
    Loading...
  </div>
);
   }

  return (
    <>
      {/* <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title={blog.title} />
      </Section> */}
      <Section topMd={170} bottomMd={20} bottomLg={54}>
        <div className="container">
          <h2>{blog.title}</h2>
        </div>
      </Section>

      <div className="container">
        <div className="cs_blog_details_info">
          <div className="cs_blog_details_info_left">
            <div className="cs_blog_details_date">
              {blog.created_at} | By {blog.author}
            </div>
          </div>
        </div>

        <Spacing md="55" />

        {blog.image && (
          <img
            src={blog.image}
            alt={blog.title}
            className="w-100 cs_radius_20"
          />
        )}

        <Spacing md="90" lg="50" />

        <div className="row">
          <div className="col-lg-8">
            <div
              className="cs_blog_details"
              dangerouslySetInnerHTML={{ __html: blog.content }}
            />
          </div>

          <div className="col-lg-4">
            {/* Sidebar stays same */}
          </div>
        </div>

        <Spacing md="100" xl="150" lg="110" />
      </div>
    </>
  );
}
